export default __webpack_public_path__ + "media/images/plans/girl_2-b336dd9467f26cb84448907ace356a66.png";